(function() {
  var BUTTON_ID = "buy-now-default";
  var REDIRECT = "/cart";
  var DEFAULT_QTY = 1;

  function getCurrentVariantId() {
    var idInput = document.querySelector('form[action="/cart/add"] [name="id"]');
    if (idInput && idInput.value) return idInput.value;
    // Fallback - get from page
    var form = document.querySelector('product-form form');
    if (form) {
      var variantInput = form.querySelector('[name="id"]');
      if (variantInput) return variantInput.value;
    }
    return null;
  }

  function getDesiredQuantity() {
    var qtyInput = document.querySelector('form[action="/cart/add"] [name="quantity"]');
    if (qtyInput && qtyInput.value) {
      var n = parseInt(qtyInput.value, 10);
      if (!isNaN(n) && n > 0) return n;
    }
    return DEFAULT_QTY;
  }

  function updateCartCount() {
    document.dispatchEvent(new CustomEvent('cart:updated'));
  }

  function getSellingPlan() {
    // Check for Joy subscription widget selling plan input
    var sellingPlanInput = document.querySelector('[name="selling_plan"]');
    if (sellingPlanInput && sellingPlanInput.value) return sellingPlanInput.value;
    return null;
  }

  function addToCartThenRedirect(variantId, qty) {
    if (!variantId) {
      alert('Please select a product variant');
      return;
    }

    var cartData = { id: variantId, quantity: qty };
    var sellingPlan = getSellingPlan();
    if (sellingPlan) {
      cartData.selling_plan = sellingPlan;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(cartData)
    })
    .then(function(res) {
      if (!res.ok) throw new Error("Add to cart failed");
      return res.json();
    })
    .then(function() {
      updateCartCount();
      window.location.href = REDIRECT;
    })
    .catch(function(err) {
      console.error('Buy Now error:', err);
      alert('Sorry, we could not add this item to your cart. Please try again.');
    });
  }

  function initBuyNowButton() {
    var btn = document.getElementById(BUTTON_ID);
    if (btn && !btn.dataset.initialized) {
      btn.dataset.initialized = 'true';
      btn.addEventListener('click', function() {
        var variantId = getCurrentVariantId();
        var qty = getDesiredQuantity();
        addToCartThenRedirect(variantId, qty);
      });
    }
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBuyNowButton);
  } else {
    initBuyNowButton();
  }
})();
